import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';

export const orderConfig: DeepPartial<OrderConfig> = {
  hasCo2Compensation: false,
  premium: {
    enabled: true,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
};
